/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AioRouteImport } from './routes/aio'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as PersonasRouteImport } from './routes/personas'
import { Route as ScenariosRouteImport } from './routes/scenarios'
import { Route as SegmentsRouteImport } from './routes/segments'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics.index'
import { Route as AnalyticsReportIdRouteImport } from './routes/analytics.$reportId'
import { Route as ContactsContactIdRouteImport } from './routes/contacts.$contactId'
import { Route as PersonasIndexRouteImport } from './routes/personas.index'
import { Route as PersonasPersonaIdRouteImport } from './routes/personas.$personaId'
import { Route as ScenariosIndexRouteImport } from './routes/scenarios.index'
import { Route as ScenariosScenarioIdRouteImport } from './routes/scenarios.$scenarioId'
import { Route as ScenariosNewRouteImport } from './routes/scenarios.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AioRoute = AioRouteImport.update({
  id: '/aio',
  path: '/aio',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsRoute = AlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsRoute = ContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonasRoute = PersonasRouteImport.update({
  id: '/personas',
  path: '/personas',
  getParentRoute: () => rootRouteImport,
} as any)
const ScenariosRoute = ScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => rootRouteImport,
} as any)
const SegmentsRoute = SegmentsRouteImport.update({
  id: '/segments',
  path: '/segments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AnalyticsReportIdRoute = AnalyticsReportIdRouteImport.update({
  id: '/$reportId',
  path: '/$reportId',
  getParentRoute: () => AnalyticsRoute,
} as any)
const ContactsContactIdRoute = ContactsContactIdRouteImport.update({
  id: '/$contactId',
  path: '/$contactId',
  getParentRoute: () => ContactsRoute,
} as any)
const PersonasIndexRoute = PersonasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PersonasRoute,
} as any)
const PersonasPersonaIdRoute = PersonasPersonaIdRouteImport.update({
  id: '/$personaId',
  path: '/$personaId',
  getParentRoute: () => PersonasRoute,
} as any)
const ScenariosIndexRoute = ScenariosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ScenariosRoute,
} as any)
const ScenariosScenarioIdRoute = ScenariosScenarioIdRouteImport.update({
  id: '/$scenarioId',
  path: '/$scenarioId',
  getParentRoute: () => ScenariosRoute,
} as any)
const ScenariosNewRoute = ScenariosNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ScenariosRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/aio': typeof AioRoute
  '/alerts': typeof AlertsRoute
  '/analytics': typeof AnalyticsRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/contacts': typeof ContactsRouteWithChildren
  '/inbox': typeof InboxRoute
  '/personas': typeof PersonasRouteWithChildren
  '/scenarios': typeof ScenariosRouteWithChildren
  '/segments': typeof SegmentsRoute
  '/settings': typeof SettingsRoute
  '/analytics/$reportId': typeof AnalyticsReportIdRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/personas/$personaId': typeof PersonasPersonaIdRoute
  '/scenarios/$scenarioId': typeof ScenariosScenarioIdRoute
  '/scenarios/new': typeof ScenariosNewRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/personas/': typeof PersonasIndexRoute
  '/scenarios/': typeof ScenariosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aio': typeof AioRoute
  '/alerts': typeof AlertsRoute
  '/calendar': typeof CalendarRoute
  '/contacts': typeof ContactsRouteWithChildren
  '/inbox': typeof InboxRoute
  '/segments': typeof SegmentsRoute
  '/settings': typeof SettingsRoute
  '/analytics/$reportId': typeof AnalyticsReportIdRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/personas/$personaId': typeof PersonasPersonaIdRoute
  '/scenarios/$scenarioId': typeof ScenariosScenarioIdRoute
  '/scenarios/new': typeof ScenariosNewRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/personas': typeof PersonasIndexRoute
  '/scenarios': typeof ScenariosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/aio': typeof AioRoute
  '/alerts': typeof AlertsRoute
  '/analytics': typeof AnalyticsRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/contacts': typeof ContactsRouteWithChildren
  '/inbox': typeof InboxRoute
  '/personas': typeof PersonasRouteWithChildren
  '/scenarios': typeof ScenariosRouteWithChildren
  '/segments': typeof SegmentsRoute
  '/settings': typeof SettingsRoute
  '/analytics/$reportId': typeof AnalyticsReportIdRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/personas/$personaId': typeof PersonasPersonaIdRoute
  '/scenarios/$scenarioId': typeof ScenariosScenarioIdRoute
  '/scenarios/new': typeof ScenariosNewRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/personas/': typeof PersonasIndexRoute
  '/scenarios/': typeof ScenariosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/aio'
    | '/alerts'
    | '/analytics'
    | '/calendar'
    | '/contacts'
    | '/inbox'
    | '/personas'
    | '/scenarios'
    | '/segments'
    | '/settings'
    | '/analytics/$reportId'
    | '/contacts/$contactId'
    | '/personas/$personaId'
    | '/scenarios/$scenarioId'
    | '/scenarios/new'
    | '/analytics/'
    | '/personas/'
    | '/scenarios/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aio'
    | '/alerts'
    | '/calendar'
    | '/contacts'
    | '/inbox'
    | '/segments'
    | '/settings'
    | '/analytics/$reportId'
    | '/contacts/$contactId'
    | '/personas/$personaId'
    | '/scenarios/$scenarioId'
    | '/scenarios/new'
    | '/analytics'
    | '/personas'
    | '/scenarios'
  id:
    | '__root__'
    | '/'
    | '/aio'
    | '/alerts'
    | '/analytics'
    | '/calendar'
    | '/contacts'
    | '/inbox'
    | '/personas'
    | '/scenarios'
    | '/segments'
    | '/settings'
    | '/analytics/$reportId'
    | '/contacts/$contactId'
    | '/personas/$personaId'
    | '/scenarios/$scenarioId'
    | '/scenarios/new'
    | '/analytics/'
    | '/personas/'
    | '/scenarios/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AioRoute: typeof AioRoute
  AlertsRoute: typeof AlertsRoute
  AnalyticsRoute: typeof AnalyticsRouteWithChildren
  CalendarRoute: typeof CalendarRoute
  ContactsRoute: typeof ContactsRouteWithChildren
  InboxRoute: typeof InboxRoute
  PersonasRoute: typeof PersonasRouteWithChildren
  ScenariosRoute: typeof ScenariosRouteWithChildren
  SegmentsRoute: typeof SegmentsRoute
  SettingsRoute: typeof SettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aio': {
      id: '/aio'
      path: '/aio'
      fullPath: '/aio'
      preLoaderRoute: typeof AioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts': {
      id: '/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts': {
      id: '/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personas': {
      id: '/personas'
      path: '/personas'
      fullPath: '/personas'
      preLoaderRoute: typeof PersonasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scenarios': {
      id: '/scenarios'
      path: '/scenarios'
      fullPath: '/scenarios'
      preLoaderRoute: typeof ScenariosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/segments': {
      id: '/segments'
      path: '/segments'
      fullPath: '/segments'
      preLoaderRoute: typeof SegmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/analytics/$reportId': {
      id: '/analytics/$reportId'
      path: '/$reportId'
      fullPath: '/analytics/$reportId'
      preLoaderRoute: typeof AnalyticsReportIdRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/contacts/$contactId': {
      id: '/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof ContactsContactIdRouteImport
      parentRoute: typeof ContactsRoute
    }
    '/personas/': {
      id: '/personas/'
      path: '/'
      fullPath: '/personas/'
      preLoaderRoute: typeof PersonasIndexRouteImport
      parentRoute: typeof PersonasRoute
    }
    '/personas/$personaId': {
      id: '/personas/$personaId'
      path: '/$personaId'
      fullPath: '/personas/$personaId'
      preLoaderRoute: typeof PersonasPersonaIdRouteImport
      parentRoute: typeof PersonasRoute
    }
    '/scenarios/': {
      id: '/scenarios/'
      path: '/'
      fullPath: '/scenarios/'
      preLoaderRoute: typeof ScenariosIndexRouteImport
      parentRoute: typeof ScenariosRoute
    }
    '/scenarios/$scenarioId': {
      id: '/scenarios/$scenarioId'
      path: '/$scenarioId'
      fullPath: '/scenarios/$scenarioId'
      preLoaderRoute: typeof ScenariosScenarioIdRouteImport
      parentRoute: typeof ScenariosRoute
    }
    '/scenarios/new': {
      id: '/scenarios/new'
      path: '/new'
      fullPath: '/scenarios/new'
      preLoaderRoute: typeof ScenariosNewRouteImport
      parentRoute: typeof ScenariosRoute
    }
  }
}

interface AnalyticsRouteChildren {
  AnalyticsReportIdRoute: typeof AnalyticsReportIdRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
}

const AnalyticsRouteChildren: AnalyticsRouteChildren = {
  AnalyticsReportIdRoute: AnalyticsReportIdRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
}

const AnalyticsRouteWithChildren = AnalyticsRoute._addFileChildren(
  AnalyticsRouteChildren,
)

interface ContactsRouteChildren {
  ContactsContactIdRoute: typeof ContactsContactIdRoute
}

const ContactsRouteChildren: ContactsRouteChildren = {
  ContactsContactIdRoute: ContactsContactIdRoute,
}

const ContactsRouteWithChildren = ContactsRoute._addFileChildren(
  ContactsRouteChildren,
)

interface PersonasRouteChildren {
  PersonasPersonaIdRoute: typeof PersonasPersonaIdRoute
  PersonasIndexRoute: typeof PersonasIndexRoute
}

const PersonasRouteChildren: PersonasRouteChildren = {
  PersonasPersonaIdRoute: PersonasPersonaIdRoute,
  PersonasIndexRoute: PersonasIndexRoute,
}

const PersonasRouteWithChildren = PersonasRoute._addFileChildren(
  PersonasRouteChildren,
)

interface ScenariosRouteChildren {
  ScenariosScenarioIdRoute: typeof ScenariosScenarioIdRoute
  ScenariosNewRoute: typeof ScenariosNewRoute
  ScenariosIndexRoute: typeof ScenariosIndexRoute
}

const ScenariosRouteChildren: ScenariosRouteChildren = {
  ScenariosScenarioIdRoute: ScenariosScenarioIdRoute,
  ScenariosNewRoute: ScenariosNewRoute,
  ScenariosIndexRoute: ScenariosIndexRoute,
}

const ScenariosRouteWithChildren = ScenariosRoute._addFileChildren(
  ScenariosRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AioRoute: AioRoute,
  AlertsRoute: AlertsRoute,
  AnalyticsRoute: AnalyticsRouteWithChildren,
  CalendarRoute: CalendarRoute,
  ContactsRoute: ContactsRouteWithChildren,
  InboxRoute: InboxRoute,
  PersonasRoute: PersonasRouteWithChildren,
  ScenariosRoute: ScenariosRouteWithChildren,
  SegmentsRoute: SegmentsRoute,
  SettingsRoute: SettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
